// @ts-generator-hash: 293b71f3c0e23f3a62a734e321a80887836138bea336fc62629974a5aeef0ddf
// Generation date: 9/17/2026 8:11:21 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.Models.Dtos.UploadOutcomeState
export enum UploadOutcomeState {
  Unknown = 0,
  Finishing = 1,
  Done = 2,
  Failed = 3,
}
